import type { Location } from "react-router-dom";
import { createStore } from ".";
import { createJSONStorage } from "zustand/middleware";

interface LocationProps {
  location: Location | null;
  previousLocation: Location | null;
}

interface LocationState {
  locate: LocationProps;
  setLocate: (location: Location) => void;
}

const initState = {
  location: null,
  previousLocation: null,
};

export const useLocationStore = createStore<LocationState>(
  (set, get) => ({
    locate: initState,
    setLocate: (location) =>
      set({
        locate: { location: location, previousLocation: get().locate.location },
      }),
  }),
  {
    name: "parkgolf-locate",
    storage: createJSONStorage(() => sessionStorage),
  }
);
